import { getAccountExportSettingFormConfig } from '../../../backend/config/utils/getAccountExportSettingFormConfig';
import { defineSettingMap } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
export const defaultAccountExportFieldTypeValues = [
    {
        value: 'emergencyContacts',
        label: 'Emergency Contacts',
    },
    {
        value: 'emailArray',
        label: 'Email',
    },
    {
        value: 'date',
        label: 'Date',
    },
    {
        value: 'dateTime',
        label: 'Date and Time',
    },
    {
        value: 'organizationArray',
        label: 'Organization',
    },
    {
        value: 'pagerNumberArray',
        label: 'Pager Number',
    },
    {
        value: 'phoneNumberTextArray',
        label: 'Phone Number Text',
    },
    {
        value: 'phoneNumberVoiceArray',
        label: 'Phone Number Voice',
    },
    {
        value: 'phoneNumberFaxArray',
        label: 'Phone Number Fax',
    },
    {
        value: 'string',
        label: 'Text Value',
    },
    {
        value: 'stringArray',
        label: 'Multiselect Text Values',
    },
    {
        value: 'accountCompletion',
        label: 'Account Completion',
    },
];
export const defaultExportSettingSourceFieldExclusions = [
    'organizationArray',
    'pagerNumberArray',
    'emergencyContacts',
    'accountCompletion',
];
export const defaultAccountExportValues = [
    {
        headerName: 'LAST_NAME',
        source: 'lastName',
        default: true,
    },
    {
        headerName: 'FIRST_NAME',
        source: 'firstName',
        default: true,
    },
    {
        headerName: 'EMAIL',
        source: 'email',
        default: true,
    },
    {
        headerName: 'STATUS',
        source: 'systemStatus',
        default: true,
    },
    {
        headerName: 'ADDRESS_1',
        source: 'address.addressLine1',
        default: true,
    },
    {
        headerName: 'ADDRESS_2',
        source: 'address.addressLine2',
        default: true,
    },
    {
        headerName: 'CITY',
        source: 'address.city',
        default: true,
    },
    {
        headerName: 'STATE',
        source: 'address.state',
        default: true,
    },
    {
        headerName: 'COUNTY_NAME',
        source: 'address.countyName',
        default: true,
    },
    {
        headerName: 'POSTAL_CODE',
        source: 'address.postalCode',
        default: true,
    },
    {
        headerName: 'CONTACT_EMAIL',
        type: 'emailArray',
        source: 'contactEmails',
        default: true,
    },
    {
        headerName: 'CONTACT_PHONE_NUMBER_TEXT',
        type: 'phoneNumberTextArray',
        source: 'contactPhoneNumbers',
        default: true,
    },
    {
        headerName: 'CONTACT_PHONE_NUMBER_VOICE',
        type: 'phoneNumberVoiceArray',
        source: 'contactPhoneNumbers',
        default: true,
    },
    {
        headerName: 'CONTACT_PHONE_NUMBER_FAX',
        type: 'phoneNumberFaxArray',
        source: 'contactPhoneNumbers',
        default: true,
    },
    {
        headerName: 'PAGERS',
        type: 'pagerNumberArray',
        default: true,
    },
    {
        headerName: 'ORGANIZATION_PATH',
        type: 'organizationArray',
        default: true,
    },
    {
        headerName: 'EMERGENCY_CONTACTS',
        type: 'emergencyContacts',
        default: false,
    },
    {
        headerName: 'LAST_LOGIN',
        source: 'lastLogin',
        type: 'dateTime',
        default: false,
    },
    {
        headerName: 'DATE_REGISTERED',
        source: 'created',
        type: 'dateTime',
        default: false,
    },
    {
        headerName: 'PROFILE_COMPLETION',
        type: 'accountCompletion',
        default: false,
    },
    {
        headerName: 'LAST_UPDATED',
        source: 'updated',
        type: 'dateTime',
        default: false,
    },
];
export const accountExport = defineSettingMap({
    /**
     * @public
     * */
    accountExport: {
        type: 'json',
        description: 'Account Export Fields',
        group: 'system-admin',
        defaultValue: defaultAccountExportValues,
        editModalConfig: {
            maxWidth: 'xl',
            fullWidth: false,
        },
        form: getAccountExportSettingFormConfig(defaultAccountExportFieldTypeValues, defaultExportSettingSourceFieldExclusions),
    },
});
